import styles from './selectPlayerModal.module.css';
import { PlayerCardProps } from './selectPlayerModal.types';

const PlayerCard = ({
  style,
  player,
  selectedPlayer,
  onClick,
}: PlayerCardProps) => {
  const isSelected: boolean = selectedPlayer?.playerId === player.playerId;

  return (
    <div className={`${styles.playerCard} ${style ?? ''}`}>
      <div
        className={`${styles.borderLayer} ${isSelected ? styles.selected : ''}`}
        onClick={() => onClick?.(player)}
      >
        <div className={styles.playerImageWrapper}>
          <img src={player.fullImage} alt="" />
        </div>
      </div>

      <span>#{player.playerId.slice(0, 5)}</span>
    </div>
  );
};

export default PlayerCard;
